import {
  CategoriesButton,
  CategoriesIcon,
} from '../../shared/CategoriesButton/CategoriesButton.styled';
import {
  ItemsCount,
  ProductsWrapper,
  TopSection,
} from '../CategoryProducts/CategoryProducts.styled';
import { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainWrap } from '../../layouts';
import { Paginator } from '../../shared/Paginator';
import { Product } from '../../shared/Product';
import type { ProductType } from '../../types/product';
import { SearchBar } from '../SearchBar';
import { Sidebar } from '../../base';
import { SidebarCategories } from '../../base/SidebarCategories';
import { faList } from '@fortawesome/free-solid-svg-icons';
import type { state } from '../../types/store/state';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';

export const ShowAllProducts = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const products = useSelector((state: state) => state.products);
  const [openSidebar, setOpenSidebar] = useState(false);

  const [windowWidth, setWindowWidth] = useState(global.innerWidth);
  const isMobile = windowWidth <= 639;

  useEffect(() => {
    const handleResize = () => setWindowWidth(global.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { page = '1' } = router.query;
  const prevPage = Number(Number(page)) - 1;
  const nextPage = Number(Number(page)) + 1;
  const totalPages = products.totalPages;

  const leftNum = Number(page) * products.perPage - 25 + 1;
  const rightNum =
    Number(page) === products.totalPages
      ? products.count
      : products.perPage * Number(page);

  return (
    <section>
      <MainWrap>
        <SidebarCategories />
        <div>
          <div className="categoriesButtonDiv">
            <CategoriesButton
              onClick={() => {
                setOpenSidebar(!openSidebar);
              }}
            >
              <CategoriesIcon>
                <FontAwesomeIcon icon={faList} width="14" />
              </CategoriesIcon>
              {t('header.categories.selector.title')}
            </CategoriesButton>
          </div>
          <div className="searchBarBody">
            <SearchBar />
          </div>
          <TopSection>
            <ItemsCount>
              {t('categories.count.title.showing')}
              {leftNum} - {rightNum}
              {t('categories.count.title.items')}
            </ItemsCount>
          </TopSection>
          <ProductsWrapper>
            {products.results.map((product: ProductType) => (
              <Product key={product.id} {...product} />
            ))}
          </ProductsWrapper>
        </div>
      </MainWrap>
      {openSidebar ? <Sidebar setOpenSidebar={setOpenSidebar} /> : null}
      <Paginator
        prev={`/products/?page=${prevPage}`}
        prevDisabled={products.previous === null}
        next={`/products/?page=${nextPage}`}
        nextDisabled={products.next === null}
        currentPage={Number(page)}
        isCategory={false}
        categoryNumber={0}
        totalPages={totalPages}
        maxLength={isMobile ? 5 : 7}
      />
    </section>
  );
};
